import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { PageHero } from "../components/site/PageHero";
import { PayingForServices } from "../components/site/PayingForServices";
import { CtaBand } from "../components/site/CtaBand";
import { Reveal } from "../components/site/Motion";
import { FAQS } from "../data/content";

export default function Faq() {
  return (
    <main id="main-content" data-testid="faq-page">
      <PageHero eyebrow="FAQ" lines={["Questions,", <>answered <span className="italic text-[#A9533A]">plainly.</span></>]} intro="Straight answers about payment, assessments and telehealth." testid="faq-hero" />
      <section className="bg-[#FDFBF7] pb-20 sm:pb-28">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
          <Reveal className="lg:col-span-4">
            <div className="rounded-[2rem] bg-[#F4F1EA] p-8 lg:sticky lg:top-28">
              <p className="font-serif-display text-2xl leading-snug">Still unsure about something?</p>
              <p className="mt-3 text-sm leading-relaxed text-[#4A554D]">We'll help you understand your options, no commitment needed.</p>
              <Link to="/contact" className="mt-6 inline-flex rounded-full bg-[#1E2621] px-5 py-3 text-sm font-medium text-[#F4F1EA] transition-colors hover:bg-[#A9533A]" data-testid="faq-contact-button">Ask us directly</Link>
            </div>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={0.1}>
            <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-[#E2DCD0]" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#E2DCD0]">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="group py-7 text-left hover:no-underline [&>svg]:hidden"
                  >
                    <span className="flex items-baseline gap-5">
                      <span className="font-mono-ui text-xs text-[#A9533A]">0{i + 1}</span>
                      <span className="font-serif-display text-2xl font-medium leading-snug text-[#1E2621] sm:text-3xl">{f.q}</span>
                    </span>
                    <span className="ml-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#E2DCD0] transition-all duration-500 group-data-[state=open]:rotate-45 group-data-[state=open]:bg-[#C86D51] group-data-[state=open]:text-white">
                      <Plus className="h-4 w-4" />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-7 pl-0 text-base leading-relaxed text-[#4A554D] sm:pl-10" data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <div className="border-t border-[#E2DCD0]"><PayingForServices /></div>
      <CtaBand />
    </main>
  );
}
